/* eslint-disable react/display-name */
import * as React from 'react';

const Facebook = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
    <path d="M30 6C16.7 6 5.8 16.8 5.8 30 5.8 42.7 16 53.1 28 54V37h-6v-7h6v-5.7c0-6.2 3.8-9.6 9.4-9.6 2.6 0 4.6.2 5.6.3v6.5h-4.1c-3 0-3.9 1.4-3.9 3.5v5h7.8l-.9 7H35v16.4C46 51 53.8 41.4 53.8 30 53.8 16.8 43.3 6 30 6z" />
  </svg>
);

export default Facebook;
